import { render, staticRenderFns } from "./LectureList.vue?vue&type=template&id=12f82d1c"
import script from "./LectureList.vue?vue&type=script&lang=js"
export * from "./LectureList.vue?vue&type=script&lang=js"
import style0 from "./LectureList.vue?vue&type=style&index=0&id=12f82d1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports